import { ITranslations } from "../types"
import { StubTranslationsMock } from "./mock-en-GB"

export const StubTranslations: ITranslations = {
  i18n: (key: string) => {
    try {
      const parts = key.split(":")
      const result = StubTranslationsMock[parts[0]][parts[1]]
      if (!result) return key
      if (result.trim().length === 0) return key
      return result
    } catch (error) {
      console.warn(error)
      return key
    }
  }
}
